import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from './useDictionary';

export const useNotificationsDictionary = () => {
  return useDictionary(Dictionary, DICTIONARY.Notifications);
};
